import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'

import { getVouchersAPI } from 'api/vouchers'
import { VouchersDataTypes } from 'types/vouchers'
import { DropDownItem } from 'types/components'

interface UseEVoucherRedemptionVouchersReturn {
  voucherOptions: DropDownItem[]
  vouchersData: VouchersDataTypes[]
  isLoadingVouchers: boolean
  isErrorVouchers: boolean
}

export const useEVoucherRedemptionVouchers = (
  traderId: number
): UseEVoucherRedemptionVouchersReturn => {
  const [vouchersData, setVouchersData] = useState<VouchersDataTypes[]>([])

  const {
    data: dataVouchers,
    isLoading: isLoadingVouchers,
    isError: isErrorVouchers,
  } = useQuery({
    refetchOnWindowFocus: false,
    queryKey: ['useEVoucherRedemptionVouchers', traderId],
    queryFn: async () => {
      const response = await getVouchersAPI({
        traderId,
        pSize: 50,
        pNumber: 1,
        status: 'ACTIVE',
      })
      return response.vouchers
    },
    enabled: !!traderId,
  })

  useEffect(() => {
    if (dataVouchers) {
      setVouchersData(dataVouchers)
    }
  }, [dataVouchers])

  const voucherOptions: DropDownItem[] = vouchersData.map((voucher) => ({
    label: `${voucher.name} - ${voucher.voucherCode}`,
    value: voucher.voucherCode,
  }))

  return {
    voucherOptions,
    vouchersData,
    isLoadingVouchers,
    isErrorVouchers,
  }
}
